import React from "react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import { CREATIVE_NAMES, DISPLAY_ADHESION_AD_FIELDS } from "./definitions";
import DropdownSection from "./DropdownSection";
import InputTextSection from "./InputTextSection";
import BaseCreativeControls from "./BaseCreativeControls";
const CREATIVE_TYPE = CREATIVE_NAMES.DISPLAY_ADHESION;

const COLLAPSE_AD_OPTIONS = [
    { label: "Yes", value: true },
    { label: "No", value: false },
];

export default function DisplayAdhesion({
    desktopCreativeURL,
    mobileCollapsedCreativeURL,
    desktopCollapsedCreativeURL,
    collapseDelay,
    collapseBtnWording,
    autoCollapseAd,
    handleChange,
    currentCustomer,
    impressionTag,
    clickTag,
    adServingType
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                creativeType={CREATIVE_TYPE}
                impressionTag={impressionTag}
            >
                <AssetInputOrUploadSection
                    inputValue={desktopCreativeURL}
                    inputLabel="DESKTOP AD IMAGE URL"
                    inputName={DISPLAY_ADHESION_AD_FIELDS.desktopCreativeURL}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                    tooltip="Banner for expanded creative. 970x250"
                />
                <AssetInputOrUploadSection
                    inputValue={desktopCollapsedCreativeURL}
                    inputLabel="COLLAPSED BANNER"
                    inputName={DISPLAY_ADHESION_AD_FIELDS.desktopCollapsedCreativeURL}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                    tooltip="Collapsed banner. 970x90"
                />
                <AssetInputOrUploadSection
                    inputValue={mobileCollapsedCreativeURL}
                    inputLabel="MOBILE BANNER"
                    inputName={DISPLAY_ADHESION_AD_FIELDS.mobileCollapsedCreativeURL}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                    tooltip="Mobile banner. 300x50"
                />

                <DropdownSection
                    adtype={CREATIVE_TYPE}
                    label="Auto collapse ad?"
                    changeHandler={handleChange}
                    name={DISPLAY_ADHESION_AD_FIELDS.autoCollapseAd}
                    value={autoCollapseAd}
                    options={COLLAPSE_AD_OPTIONS}
                />
                <InputTextSection
                    label={"Collapse delay (in milliseconds)"}
                    name={DISPLAY_ADHESION_AD_FIELDS.collapseDelay}
                    value={collapseDelay}
                    changeHandler={handleChange}
                    type={"input"}
                    adtype={CREATIVE_TYPE}
                    disabled={!autoCollapseAd}
                />
                <InputTextSection
                    label={"Collapse button wording"}
                    name={DISPLAY_ADHESION_AD_FIELDS.collapseBtnWording}
                    value={collapseBtnWording}
                    changeHandler={handleChange}
                    type={"input"}
                    adtype={CREATIVE_TYPE}
                    uriEncodeValue={false}
                />
            </BaseCreativeControls>
        </>
    );
}